<template>
  <div>
    <b-select
      v-model="internalControlAssessmentId"
      :error-messages="getErrorMessages(v$.internalControlAssessmentId)"
      :items="$directory.get('auditControlAssessment')"
      :loading="$loading.isLoading('auditControlAssessment')"
      label="Оцінка внутрішнього контролю"
      placeholder="Оберіть оцінку внутрішнього контролю"
      @blur="v$.internalControlAssessmentId.$touch()"
      @focus="$directory.fill('auditControlAssessment')"></b-select>
  </div>
</template>

<script lang="ts">
import { PropType, ref } from 'vue'
import { Dialog } from '@/dialog'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { fillDirectory } from '@/directory'
import { getErrorMessages } from 'best-modules/utils'
import { auditComplete } from '@/requests/audit'

export default {
  name: 'AuditComplete',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const internalControlAssessmentId = ref()
    const rules = { internalControlAssessmentId: { required: required } }
    const v$ = useVuelidate(rules, { internalControlAssessmentId })

    const submit = () => {
      return auditComplete(
        props.dialog.dialogData.auditId,
        internalControlAssessmentId.value
      ).then(res => {
        return res
      })
    }

    fillDirectory('auditControlAssessment')

    return { internalControlAssessmentId, v$, submit }
  },
}
</script>

<style lang="scss" scoped></style>
